import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig"
import React, { FC, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const RedirectLogin = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
 
    instance
      .loginPopup(loginRequest)
      .then(() => {
        console.log('============ REDIRECT LOG: [LoginRedirect] - Navigate to /loginlanding');
        navigate("/loginlanding");
      })
      .catch((error) => {
        console.error(error);
      });
  }, [instance, navigate]);

  return <div></div>;
};

export default RedirectLogin;